import React from 'react';
import './FaultDescription.scss';

const FaultDescription = ({label,name,onChange,id,placeholder}) => {

    return (
        <div className="col-xs-12">
            <div className="form-group col-xs-12 col-sm-6">
                <label htmlFor={id}>{label}</label>
                <textarea className="textarea form-control" rows="4" cols="50" name={name} onChange={onChange} placeholder={placeholder} />
            </div>
        </div>
    );
}

export default FaultDescription;


// WEBPACK FOOTER //
// ./src/components/ComplaintPositionComponents/FaultDescription/FaultDescription.js